<template>
<vs-card>
  <download-csv
    :data   = "data">
    Download Data
  </download-csv>
</vs-card>
</template>

<script>

export default {
  name: 'Setting',
  data() {
    return {
      data: [
        {id: 1, fruit: 'Apple', price: 4.50, unit: 'lb'},
        {id: 2, fruit: 'Blueberry', price: 3.00, unit: 'lb'},
        {id: 3, fruit: 'Pineapple', price: 5.15, unit: 'each'},
      ],
      fields: ['fruit', 'price', 'unit'],
    };
  },
};
</script>